import React, {Component} from 'react';
const { connect } = require('react-redux');
const { Link } = require('react-router');

import ModalGiveVirtualGift from '../modals/ModalGiveVirtualGift';
import ProfileLink from 'components/ProfileLink';
import FooterWallet from 'components/wallet/FooterWallet';

import {getMemberWallet} from 'reducers/memberWallet';
import {deleteMemberVirtualGift} from 'reducers/member';
import {formatDate} from 'utils/virtualGifts';

import {t} from 'l10n';

import 'sass/member/wallet/walletproducts.scss';

class WalletProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedVirtualGift: null
        }
    }

    componentDidMount() {
        if (this.props.virtualGifts) {
            this.props.getMemberWallet();
        }
    }

    render() {
        let {virtualGifts, currentUser, getMemberWallet, deleteMemberVirtualGift} = this.props,
            {list} = virtualGifts;

        let {selectedVirtualGift} = this.state;

        let onModalCloseFn = () => this.setState({selectedVirtualGift: null});

        return (
            <div className="ui-kit-base wallet-products">
                {selectedVirtualGift &&
                    <ModalGiveVirtualGift
                        virtualGift={selectedVirtualGift}
                        user={selectedVirtualGift.receiver}
                        currentUser={currentUser}
                        show={true}
                        closeFn={onModalCloseFn}
                        onSaveSuccess={() => { onModalCloseFn(); getMemberWallet(); }}
                    />
                }

                <div className="content">
                    <div className="ui-responsive-grid list-wallet-products">
                        {list.map((virtualGift, index) =>
                            <div key={index}>
                                <div className="item-wallet">
                                    <div className="img">
                                        <div className="edit-product">
                                            <div className="edit"
                                                 onClick={() => this.setState({selectedVirtualGift: virtualGift})}>
                                                <div className="icon"></div>
                                            </div>
                                            <div className="delete"
                                                 onClick={() => deleteMemberVirtualGift(virtualGift.id)}>
                                                <div className="icon"></div>
                                            </div>
                                        </div>
                                        <img src={virtualGift.thumbnail_url} alt=""/>
                                    </div>
                                    <div className="ui-mini text">
                                        <p>{virtualGift.name} {t('to give to')} <ProfileLink
                                            user={virtualGift.receiver}/></p>
                                    </div>
                                    <div className="date-points">
                                                                    <span className="date">
                                                                        {formatDate(virtualGift)}
                                                                    </span>
                                        <span className="points">
                                                                        {t('%1 tokens', virtualGift.points)}
                                                                    </span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <FooterWallet />
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        virtualGifts: state.memberWallet.virtualGifts
    }),({
        getMemberWallet: getMemberWallet,
        deleteMemberVirtualGift: deleteMemberVirtualGift
    })
)(WalletProducts)




// WEBPACK FOOTER //
// ./src/components/wallet/WalletProducts.js